import { Trans } from '@lingui/react';
import { ActionIcon, Menu, Text } from '@mantine/core';
import { IconDeviceFloppy, IconDots, IconTemplate, IconTrash } from '@tabler/icons';
import { FC, useContext, useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { i18n } from '@lingui/core';
import { TransButtonDefault, TransButtonPrimaryWithSpinner } from '../../Atoms/Buttons';
import { ViolationContext } from '../../Service/Context/ViolationContext';
import { LicenceS } from '../../Service/LicenceS';
import { newDocumentOfDocumentAndTemplate } from '../../Service/restapi/templateService';
import { DocumentContext } from '../../Service/Context/DocumentContextV2';
import { openDeleteConfirmModal } from '../../Atoms/DeleteConfirmModal';
import { DocumentS } from '../../Templates/Documents/DocumentS';
import { ModalDialog } from '../Dialogs';
import InjectableFooter from '../../Templates/Navigation/phone/InjectableFooter';
import DocumentEditorFooter from '../../Templates/Navigation/phone/DocumentEditorFooter';
import { WindowContext } from '../../Service/Context/WindowContext';
import { usePositionProducts } from '../../Service/hooks/usePositionProducts';
import { DocumentsContext } from '../../Service/Context/DocumentsContext';
import { openAddProductModal } from './Position/AddProductModal';
import { openCreateTemplateModal } from './DocumentModals';
import SelectDocumentTemplate from './SelectDocumentTemplate';

const DocumentActions: FC<{ showPreview: () => void }> = ({ showPreview }) => {
  const navigate: NavigateFunction = useNavigate();
  const { sm } = useContext(WindowContext);
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const { bookitupDocument, handleChange, positionHandlers } = useContext(DocumentContext);
  const { reload: reloadDocumentsPage } = useContext(DocumentsContext);
  const [loading, setLoading] = useState<boolean>(false);
  const { addProducts } = positionHandlers;
  const { id: documentId, eventId, documentType } = bookitupDocument ?? {};
  const [modalOpenSelectTemplate, setModalOpenSelectTemplate] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const { products } = usePositionProducts();

  const deleteHandler = () => {
    if (bookitupDocument) {
      const onConfirm = async () => {
        const deleted = await DocumentS.deleteDocument(bookitupDocument);
        if (deleted) {
          if (eventId) {
            navigate(`/events/${eventId}/documents`);
          } else {
            if (reloadDocumentsPage) reloadDocumentsPage();
            navigate('/documents');
          }
          return true;
        }
        return false;
      };
      openDeleteConfirmModal({
        title: i18n._('common.delete.document.confirm.head'),
        description: <Text>{i18n._('common.delete.document.confirm')}</Text>,
        onConfirm,
      });
    }
  };

  function load() {
    const fn = () => {
      if (selectedTemplate) {
        setLoading(true);
        newDocumentOfDocumentAndTemplate(documentType, selectedTemplate, documentId)
          .then((resp) => {
            if (resp.ok) {
              resp.json().then((newDocument) => {
                handleChange(newDocument);
                setModalOpenSelectTemplate(!modalOpenSelectTemplate);
                if (eventId) {
                  window.location.href = `/events/${eventId}/documents/${newDocument.id}`;
                } else {
                  window.location.href = `/documents/${newDocument.id}`;
                }
              });
            }
          })
          .finally(() => setLoading(false));
      }
    };
    if (selectedTemplate !== 'Standard') {
      executeWithLicenceCheck(LicenceS.Restrictions.MULTIPLE_DOCUMENT_TEMPLATE, fn);
    } else {
      fn();
    }
  }

  const addProduct = () =>
    executeWithLicenceCheck(LicenceS.Restrictions.PRODUCT_USAGE, () => {
      openAddProductModal({ products, onFinish: (p) => addProducts(p) });
    });

  return (
    <>
      {sm ? (
        <InjectableFooter>
          <DocumentEditorFooter
            showPreview={showPreview}
            addHandler={addProduct}
            saveAsTemplate={() => bookitupDocument && openCreateTemplateModal({ bookitupDocument })}
            loadTemplate={() => setModalOpenSelectTemplate(true)}
            remove={deleteHandler}
          />
        </InjectableFooter>
      ) : (
        <Menu shadow="md" transition="scale-y" position="bottom-end">
          <Menu.Target>
            <ActionIcon>
              <IconDots />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={() => setModalOpenSelectTemplate(true)} icon={<IconTemplate size={16} />}>
              Vorlage auswählen
            </Menu.Item>
            {bookitupDocument && (
              <Menu.Item
                onClick={() => openCreateTemplateModal({ bookitupDocument })}
                icon={<IconDeviceFloppy size={16} />}
              >
                Vorlage speichern
              </Menu.Item>
            )}
            <Menu.Item color="red" onClick={deleteHandler} icon={<IconTrash size={16} />}>
              Löschen
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      )}

      {/* {documentType && (
        <SaveTemplateName
          entityId={documentId}
          documentType={documentType}
          open={openSaveTemplateNameDialog}
          close={() => setOpenSaveTemplateNameDialog(false)}
        />
      )} */}

      <ModalDialog
        header={<Trans id="template.apply" />}
        body={
          <SelectDocumentTemplate
            value={selectedTemplate}
            onChange={(option: any) => setSelectedTemplate(option.value)}
          />
        }
        footer={
          <div>
            <TransButtonDefault
              onClickHandler={() => setModalOpenSelectTemplate(!modalOpenSelectTemplate)}
              text="actions.close"
            />
            <TransButtonPrimaryWithSpinner isLoading={loading} onClickHandler={() => load()} text="actions.apply" />{' '}
          </div>
        }
        show={modalOpenSelectTemplate}
        toggle={() => setModalOpenSelectTemplate(!modalOpenSelectTemplate)}
      />
    </>
  );
};

export default DocumentActions;
